import { AppDispatch, RootState } from 'store'
import { NavBar } from '../../components/NavBar/NavBar'
import {
    Flex,
    Button,
    Separator,
    H1WithBack,
    PageWrapper,
    PageFooter,
} from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { clearAccommodationInfo, getSingleAccommodationInfo } from 'features/accommodation/accommodationSlice'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { SmallTable, SmallThead } from 'components/SmallTable/SmallTable.styled'
import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import { OtherText, TitleText } from 'styling/Typography'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { formatDateForDisplay } from 'utils/helpers'

export const ViewAccommodation = () => {
    const { singleAccommodationInfo } = useSelector((store: RootState) => store.accomodation)
    const { id } = useParams()
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(getSingleAccommodationInfo(id))
        return (() => {
            dispatch(clearAccommodationInfo())
        })
    }, [id])


    return (
        <>
            <NavBar />
            <PageWrapper noFooter >
                <H1WithBack title={(singleAccommodationInfo?.name || '') + ' - ' + (singleAccommodationInfo?.address || '-')} arrow />
                <Separator />
                <Flex gap='1rem' >
                    <FuelTableContainer>
                        <Flex width='100%' between >
                            <TitleText weight='bold' >ASSIGNED EMPLOYEES</TitleText>
                        </Flex>
                        {!singleAccommodationInfo?.assignedUsers?.length ? (
                            <Flex width='100%'  ><NoItems marginTop='2rem' smallText title='Assigned Employees' /></Flex>
                        ) : (
                            <Flex column width='100%' alignEnd gap='1rem'>
                                <SmallTable>
                                    <SmallThead>
                                        <tr>
                                            <th>Name</th>
                                        </tr>
                                    </SmallThead>

                                    <tbody>
                                        {
                                            singleAccommodationInfo?.assignedUsers.map((item) => {
                                                return (
                                                    <tr key={item.id || '/'} >
                                                        <td>{item.firstName + ' ' + item.lastName || '/'}</td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </SmallTable>

                            </Flex>
                        )}
                    </FuelTableContainer>
                    <FuelTableContainer>
                        <Flex width='100%' between >
                            <TitleText weight='bold' >ASSIGNED GUESTS</TitleText>
                        </Flex>
                        {!singleAccommodationInfo?.assignedGuests?.length ? (
                            <Flex width='100%'  ><NoItems marginTop='2rem' smallText title='Assigned Guests' /></Flex>
                        ) : (
                            <Flex column width='100%' alignEnd gap='1rem'>
                                <SmallTable>
                                    <SmallThead>
                                        <tr>
                                            <th>Name</th>
                                        </tr>
                                    </SmallThead>

                                    <tbody>
                                        {
                                            singleAccommodationInfo?.assignedGuests.map((item) => {
                                                return (
                                                    <tr key={item.id || '/'} >
                                                        <td>{item.firstName + ' ' + item.lastName || '/'}</td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </SmallTable>

                            </Flex>
                        )}
                    </FuelTableContainer>
                    <FuelTableContainer>
                        <Flex width='100%' between >
                            <TitleText weight='bold' >REQUESTS</TitleText>
                        </Flex>
                        {!singleAccommodationInfo?.requests?.length ? (
                            <Flex width='100%'  ><NoItems marginTop='2rem' smallText title='Requests' /></Flex>
                        ) : (
                            <Flex column width='100%' alignEnd gap='1rem'>
                                <SmallTable>
                                    <SmallThead>
                                        <tr>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Number of nights</th>
                                            <th>Status</th>
                                        </tr>
                                    </SmallThead>

                                    <tbody>
                                        {
                                            singleAccommodationInfo?.requests.map((item) => {
                                                return (
                                                    <tr key={item.id || '/'} >
                                                        <td>{item.startDate ? formatDateForDisplay(item.startDate) : '/'}</td>
                                                        <td>{item.endDate ? formatDateForDisplay(item.endDate) : '/'}</td>
                                                        <td>{item.numberOfNights || '/'}</td>
                                                        <td>{item.status == 1 ? 'Checked In' : 'Chechked Out'}</td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </SmallTable>

                            </Flex>
                        )}
                    </FuelTableContainer>
                </Flex>
            </PageWrapper>

        </>
    )
}
